export enum Constants {
  CONTRACT_SET_LOADING = 'CONTRACT_SET_LOADING',
  CONTRACT_CREATE_DROP = 'CONTRACT_CREATE_DROP'
}